module.exports = __webpack_public_path__ + "img/base_divers_camping_car.58c8bf66.svg";